(() => {
  const routes = window.silhouetteRoutes || { add: '/cart/add', cart: '/cart' };
  const toast = document.querySelector('.sil-toast');
  let toastTimer;
  function notify(message) {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 3500);
  }
  async function addItem(id, quantity = 1) {
    const response = await fetch(`${routes.add}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(id), quantity })
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'Could not add this item');
    return data;
  }
  async function refreshCartCount() {
    try {
      const response = await fetch(`${routes.cart}.js`, { headers: { 'Accept': 'application/json' } });
      const cart = await response.json();
      document.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = cart.item_count; });
      const link = document.querySelector('.sil-cart-link');
      if (link) link.setAttribute('aria-label', `Cart, ${cart.item_count} items`);
    } catch (_) { /* Cart page remains the source of truth. */ }
  }
  document.addEventListener('click', async event => {
    const cardButton = event.target.closest('[data-card-action]');
    if (cardButton) {
      if (cardButton.dataset.needsOptions === 'true') {
        window.location.assign(cardButton.dataset.productUrl);
        return;
      }
      if (cardButton.disabled) return;
      cardButton.disabled = true;
      const originalText = cardButton.textContent;
      cardButton.textContent = 'Adding…';
      try {
        await addItem(cardButton.dataset.variantId);
        if (cardButton.dataset.cardAction === 'buy') { window.location.assign('/checkout'); return; }
        await refreshCartCount();
        notify('Added to cart');
      } catch (error) { notify(error.message); }
      cardButton.textContent = originalText;
      cardButton.disabled = false;
      return;
    }
    const galleryButton = event.target.closest('[data-gallery-image]');
    if (galleryButton) {
      const featured = document.querySelector('.sil-product-gallery__featured');
      if (featured) { featured.src = galleryButton.dataset.galleryImage; featured.alt = galleryButton.dataset.galleryAlt; featured.srcset = ''; }
    }
    const buyButton = event.target.closest('[data-product-buy]');
    if (buyButton) {
      const form = buyButton.closest('form');
      const variant = form && form.querySelector('[name="id"]');
      const quantity = form && form.querySelector('[name="quantity"]');
      if (!variant) return;
      buyButton.disabled = true;
      buyButton.textContent = 'Adding…';
      try { await addItem(variant.value, Math.max(1, Number(quantity?.value) || 1)); window.location.assign('/checkout'); }
      catch (error) { notify(error.message); buyButton.disabled = false; buyButton.textContent = 'Buy now'; }
    }
  });
  const variantSelect = document.querySelector('[data-product-variant-select]');
  if (variantSelect) variantSelect.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    const price = document.querySelector('[data-product-price]');
    if (price && option) price.textContent = option.dataset.price;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantSelect.value);
    window.history.replaceState({}, '', url);
  });
})();
